import { useState } from "react";
import { useParams } from "react-router-dom";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import { useGetTaxRollByIdQuery } from "../taxRollApi";
import { useGetCollectorByIdQuery } from "../../collector/collector";

const UpdateTaxRoll = () => {

    const { rollId } = useParams();


    const taxRollData = useGetTaxRollByIdQuery(rollId);

    const collectorData = useGetCollectorByIdQuery(taxRollData?.data?.collectorId)
    const [installmentFrequency, setInstallmentFrequency] = useState("OTHER");
    const [receivableType, setReceivableType] = useState("Fee");
    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "Tax Roll", url: "/tax-rolls" },
        { content: "Tax Roll Detail", url: "" }
    ]
    )

   
    return (
        <>
            <div className="px-4 py-2">

                <div className={"justify-between sm:block md:flex lg:flex"}>
                    <Breadcrumb crumbs={crumbs} />
                </div>

                <div className="flex justify-center mt-3">
                    <div className="bg-text-0 lg:w-4/6 sm:w-full p-5 rounded-md shadow-[0_0_10px_-2px_rgba(0,0,0,0.2)]">
                        <h3 className="text-xl font-semibold text-surface-0 pb-3 border-b border-surface-7 mb-4">TaxRoll Detail Page
                        </h3>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Collector
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="keyId"
                                    value={collectorData?.data?.name}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>

                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Source File Id
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="keyId"
                                    value={taxRollData?.data?.sourceFileId}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Staging
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="keyId"
                                    value={taxRollData?.data?.staging}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Delinquency Date
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="keyId"
                                    value={taxRollData?.data?.delinquencyDate}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Suit No. Date
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="keyId"
                                    value={taxRollData?.data?.suitNumber}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>

                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Tax Account No.
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="keyId"
                                    value={taxRollData?.data?.taxAccountNumber}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Appraisal District No.
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="keyId"
                                    value={taxRollData?.data?.appraisalDistrictNumber}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Tax Year
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="keyId"
                                    value={taxRollData?.data?.taxYear}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Tax Unit
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="keyId"
                                    value={taxRollData?.data?.taxUnit}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Base Tax
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="keyId"
                                    value={taxRollData?.data?.baseTax}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Base Tax Due
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="keyId"
                                    value={taxRollData?.data?.baseTaxDue}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Current Tax Due
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="keyId"
                                    value={taxRollData?.data?.currentTaxDue}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Overlap Account No.
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="keyId"
                                    value={taxRollData?.data?.overlapAccountNumber}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Overlap County
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="keyId"
                                    value={taxRollData?.data?.overlapCounty}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Suit Flag
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="keyId"
                                    value={taxRollData?.data?.suitFlag}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Installment Frequency
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="keyId"
                                    value={installmentFrequency}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Deferral
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="keyId"
                                    value={taxRollData?.data?.deferral}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Receivable Type Levy
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="keyId"
                                    value={receivableType}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>

                    </div>
                </div>

            </div >
        </>
    )
};
export default UpdateTaxRoll;

